var $e2e63adb0c1f3db6$exports = {};
$e2e63adb0c1f3db6$exports = {
    "dismiss": `Odbaci`
};


export {$e2e63adb0c1f3db6$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
